import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { ApiClientsPage } from './ApiClientsPage';
import { CompanionGroupCard, CompanionMemberPage } from './CompanionAdmin';
import { OmpLinkPage } from './OmpLinkPage';

// The group page's "Companion app" card (spec 2.4).
registerSettingsCard('companion', CompanionGroupCard);

/** Pages of this area (Companion app admin, API clients, needs matching, OMP link). Owned by Phase 2 task W14; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/api-clients', element: <ApiClientsPage />, permission: 'api_clients.view' },
  { path: '/manage/integrations/omp', element: <OmpLinkPage />, permission: 'omp_link.view' },
  { path: '/manage/members/:memberId/companion', element: <CompanionMemberPage />, permission: 'groups.view_members' },
];
